import React, { useState, useEffect } from 'react';

const EstimateSimulator = () => {
  const [plan, setPlan] = useState('data');
  const [pages, setPages] = useState(4);
  const [copies, setCopies] = useState(10);
  const [options, setOptions] = useState({
    seating: false,
    rush: false,
    customPages: 0,
    testPrint: false,
    premiumPaper: false
  });
  const [price, setPrice] = useState(0);

  const dataPrices = { 4: 20000, 8: 26000, 12: 35000, 16: 45000 };
  const printPrices = {
    4: { 50: 25000, 200: 26000 },
    8: { 50: 32000, 200: 35500 },
    12: { 50: 42000, 200: 45500 },
    16: { 50: 52000, 200: 55500 }
  };

  const getPrintPrice = () => {
    if (copies <= 50) {
      return printPrices[pages][50];
    } else if (copies <= 100) {
      const extraSteps = Math.floor((copies - 50) / 10);
      return printPrices[pages][50] + extraSteps * 500;
    } else {
      return printPrices[pages][200];
    }
  };

  useEffect(() => {
    let base = plan === 'data' ? dataPrices[pages] : getPrintPrice();
    let optionCost = 0;

    if (options.seating) optionCost += plan === 'data' ? 4000 : 3500;
    if (options.rush) optionCost += 10000;
    if (options.customPages > 0) optionCost += options.customPages * 3000;
    if (plan === 'print') {
      if (options.testPrint) optionCost += 5000;
      if (options.premiumPaper) optionCost += 2000;
    }

    setPrice(base + optionCost);
  }, [plan, pages, copies, options]);

  return (
    <div className="bg-neutral-50 p-6 sm:p-8 rounded-2xl shadow-sm space-y-6 text-gray-800" style={{ fontFamily: 'Pretendard, Noto Sans JP, sans-serif' }}>
      {/* ヘッダー */}
      <h3 className="text-xl sm:text-2xl font-semibold text-center text-gray-800">見積もりシミュレーター</h3>

      {/* プラン・ページ・部数 */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1 text-gray-600">プラン</label>
          <select value={plan} onChange={(e) => setPlan(e.target.value)} className="w-full p-2 border border-neutral-300 rounded-md text-sm">
            <option value="data">データ納品</option>
            <option value="print">印刷込み</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-gray-600">ページ数</label>
          <select value={pages} onChange={(e) => setPages(Number(e.target.value))} className="w-full p-2 border border-neutral-300 rounded-md text-sm">
            <option value={4}>4P</option>
            <option value={8}>8P</option>
            <option value={12}>12P</option>
            <option value={16}>16P</option>
          </select>
        </div>

        {plan === 'print' && (
          <div>
            <label className="block text-sm font-medium mb-1 text-gray-600">部数</label>
            <input
              type="number"
              min={10}
              max={200}
              step={10}
              value={copies}
              onChange={(e) => setCopies(Number(e.target.value))}
              className="w-full p-2 border border-neutral-300 rounded-md text-sm"
            />
          </div>
        )}
      </div>

      {/* オプション */}
      <div className="space-y-3">
        <h4 className="text-sm font-semibold text-gray-700 border-b border-neutral-300 pb-1">オプション</h4>

        <label className="flex items-center gap-2 text-sm text-gray-700">
          <input type="checkbox" checked={options.seating} onChange={(e) => setOptions({ ...options, seating: e.target.checked })} />
          席次表作成（+{plan === 'data' ? '¥4,000' : '¥3,500'}）
        </label>

        <label className="flex items-center gap-2 text-sm text-gray-700">
          <input type="checkbox" checked={options.rush} onChange={(e) => setOptions({ ...options, rush: e.target.checked })} />
          お急ぎ納品（+¥10,000）
        </label>

        <label className="flex items-center gap-2 text-sm text-gray-700">
          オリジナルページ数:
          <input
            type="number"
            min={0}
            value={options.customPages}
            onChange={(e) => setOptions({ ...options, customPages: Number(e.target.value) })}
            className="p-2 border border-neutral-300 rounded-md w-24 text-sm"
          />
        </label>

        {plan === 'print' && (
          <>
            <label className="flex items-center gap-2 text-sm text-gray-700">
              <input type="checkbox" checked={options.testPrint} onChange={(e) => setOptions({ ...options, testPrint: e.target.checked })} />
              試し刷り（+¥5,000）
            </label>

            <label className="flex items-center gap-2 text-sm text-gray-700">
              <input type="checkbox" checked={options.premiumPaper} onChange={(e) => setOptions({ ...options, premiumPaper: e.target.checked })} />
              上質紙に変更（+¥2,000）
            </label>
          </>
        )}
      </div>

      {/* 合計 */}
      <div className="pt-4 border-t border-gray-200 text-right">
        <p className="text-xs text-gray-500">※価格は参考です。正式な料金はご注文後に確定します。</p>
        <div className="text-xl font-bold text-gray-800 mt-2">合計金額：¥{price.toLocaleString()}</div>
      </div>
    </div>
  );
};

export default EstimateSimulator;
